import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { LinkTargetsProvider } from "./context/LinkTargetsContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TitleManager from "./components/TitleManager";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import WikiIndex from "./pages/WikiIndex";
import ArticlePage from "./pages/ArticlePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import CreditsPage from "./pages/CreditsPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import AdminUserDetail from "./pages/AdminUserDetail";
import HallOfFame from "./pages/HallOfFame";
import HallOfShame from "./pages/HallOfShame";
import BetsPage from "./pages/BetsPage";
import SettingsPage from "./pages/SettingsPage";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <LinkTargetsProvider>
            <TitleManager />
            <Navbar />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/wiki" element={<WikiIndex />} />
              <Route path="/hall-of-fame" element={<HallOfFame />} />
              <Route path="/hall-of-shame" element={<HallOfShame />} />
              <Route path="/wiki/:slug" element={<ArticlePage />} />
              <Route path="/en/wiki/:slug" element={<ArticlePage forceLang="en" />} />
              <Route path="/nl/wiki/:slug" element={<ArticlePage forceLang="nl" />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/credits" element={<ProtectedRoute><CreditsPage /></ProtectedRoute>} />
              <Route path="/credits/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
              <Route path="/my-bets" element={<ProtectedRoute><BetsPage /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
              <Route path="/admin/users/:id" element={<ProtectedRoute adminOnly><AdminUserDetail /></ProtectedRoute>} />
            </Routes>
            <Footer />
            <Toaster position="top-right" theme="dark" richColors />
            </LinkTargetsProvider>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
